import * as React from 'react';
import { useState, useRef, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { withRouter, useHistory} from "react-router-dom";
import { Colors, Constants, Languages} from '../../common';
import { styled, useTheme } from '@mui/material/styles';
import {Skeleton, Snackbar, useMediaQuery, Dialog, DialogTitle, DialogContent, DialogActions, Button} from '@mui/material';
import MuiAlert from '@mui/material/Alert';
import PlanItem from '../Plan/PlanItem';
import { actions } from '../../redux/UserRedux';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { getApiHeader } from '../../utils/CommonFunctions';
import { UserAPI } from '../../services';

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const stripePromise = loadStripe(Constants.StripePublishKey);


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
      padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
      padding: theme.spacing(1),
    },
}));

function BootstrapDialogTitle(props) {
    const { children, onClose, ...other } = props;
  
    return (
      <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
        {children}
        {/* {onClose ? (
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        ) : null} */}
      </DialogTitle>
    );
}

const PurchasePlan = () => {

    const dispatch = useDispatch();
    const history = useHistory();
    
    const [openModal, setOpenModal] = React.useState(false);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    const isLoading = useSelector((state) => state.user.isLoading);
    const planList = useSelector((state) => state.user.planList);
    const colorData = useSelector((state) => state.user.colorData);
    const showSearch = useSelector((state) => state.user.showSearch);
    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState("");
    const [msgType, setMsgType] = useState(Constants.SnackBarType.Error);

    useEffect(() => {
        // openCloseAlert(true, (pageType == Languages.TopupESIM) ? Languages.TopupAlert : Languages.PurchaseAlert, Languages.PlanDetails);
        
        
        sessionStorage.setItem('type',Languages.Purchase)
        getPlanList(12,Languages.Local, 1, 30)
      
    }, []);

    const updateShowMsg = useCallback((val) => {
        dispatch(actions.updateShowMsg(val));
    }, [dispatch]);

    const openLoader = useCallback(() => {
        actions.openLoader(dispatch);
    }, [dispatch]);

    const openCloseAlert = useCallback((isShowAlert, msg, page) => {
        dispatch(actions.openCloseAlert(isShowAlert, msg, page));
    }, [dispatch]);

    const closeLoader = useCallback(() => {
        actions.closeLoader(dispatch);
    }, [dispatch]);

 
    const getPlanList = useCallback((id, pageType, startRange, endRange) => {
        actions.getPlanList(dispatch, id, pageType, startRange, endRange);
    }, [dispatch]);

    const clearPlanList = useCallback(() => {
        actions.clearPlanList(dispatch);
    }, [dispatch]);

    const getTelsimPlanList = useCallback((id, pageType) => {
        actions.getTelsimPlanList(dispatch, id, pageType);
    }, [dispatch]);

  
    const handleModalOpen = () => {
        setOpenModal(true);
    };

    const handleModalClose = () => {
        setOpenModal(false);
    };

    const showMsg = (message, type) => {
        setMessage(message);
        setMsgType(type);
        setOpen(true);
    }

    const handleClose = (event, reason) => {
        // if (reason === 'clickaway') {
        //   return;
        // }
        updateShowMsg(false)
        setOpen(false);
    };

    const onContinueAddAMobilePlan = async (data, pageType, url) => {
        openLoader()
        let headers 	= await getApiHeader();
        const response = await UserAPI.postData(data, headers, url)
        console.log('TopUp ==>', response);
        if(response !== undefined){
            if(response.status === 200){

                if(response.status === 200){
                    if(response.status === 200){
                        showMsg(response.message,Constants.SnackBarType.Success);
                        setTimeout(() => {
                            history.push('/home');
                        }, 700);  
                    }
                    
                }

            } else {
                closeLoader();
                showMsg(response.message, Constants.SnackBarType.Error)

            }
        }else {
            closeLoader()
            showMsg(Languages.ServerError, Constants.SnackBarType.Error);
        }
    }

    
    return(
        <div className="kt-content  kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor" id="kt_content"> 
            <Snackbar open={open} autoHideDuration={6000} onClose={handleClose} anchorOrigin={{ 'horizontal': 'center', 'vertical': 'bottom'}}>
                <Alert onClose={handleClose} severity={msgType} sx={{ width: '100%' }}>
                {message}
                </Alert>
            </Snackbar>
            <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid">
                <div className="row">
                    <div className="col-lg-12 col-xl-12 order-lg-1 order-xl-1">
                        <div className="kt-grid__item kt-grid__item--fluid kt-app__content">
                            <div className="kt-portlet" style={{marginTop: 20}}>
                                <div className="kt-portlet__head">
                                    <div className="kt-portlet__head-label">
                                        {isLoading == false ? (
                                        <h3 className="kt-portlet__head-title">Add eSIM</h3>
                                        ) : (
                                            <Skeleton animation="wave" sx={{borderRadius: 1}} width={150} variant="text"/>
                                        )}
                                    </div>
                                </div>
                                <Elements stripe={stripePromise}>
                                {showSearch == false && (<>
                                    {isLoading == false ? (<>
                                        {planList && (<div className='row' style={{marginLeft: isMobile ? 15 : 50, marginRight: isMobile ? 15 : 50, marginTop: 20}}>
                                            
                                            <h2 className="addplanSubHead">Choose your plan</h2>
                                            <p className="addplanSubtext"><i className="fa fa-hand-o-right"></i>  Get the right plan for you. Plans can be upgraded in the future</p>

                                            {planList.map((item, i)=>(
                                                <PlanItem 
                                                showMsg={showMsg}
                                                key={"id" + i}
                                                type={Languages.Local}
                                                colorInfo={colorData}
                                                planData={item}
                                                onContinue={onContinueAddAMobilePlan}/>
                                            ))}
                                        </div>)
                                        }
                                    </>) : (
                                    <div className='row' style={{marginLeft: isMobile ? 15 : 80, marginRight: isMobile ? 15 : 80, marginTop: 20}}>
                                    {Constants.ButtonList.map(item=>(
                                        <div className={'col-lg-4'}>
                                            {/* <div className='col-lg-4 cntryBox' style={{marginTop: 30, padding: 0,margin: 0}}> */}
                                            <Skeleton className='cntryBox' animation="wave" sx={{borderRadius: 1}} width={'100%'} height={80}/> 
                                            
                                        </div>
                                       
                                    ))}
                                    </div>)}
                                </>)}
                                </Elements>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
    );
}

export default withRouter(PurchasePlan);